var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProceedToTakeTestBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 216,
    viewBox: "0 0 421 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7334_12805",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 421,
    height: 216
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 421,
    height: 216,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7334_12805)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.476 42.0277C437.476 42.0277 425.736 60.1864 337.73 64.5279C271.129 67.8123 145.773 7.97535 69.9333 11.8261C-8.12325 15.7523 0.262291 55.4674 0.262291 28.8522V68.6429C0.262291 68.6429 26.3285 31.2306 71.6388 31.5704C138.268 32.1367 275.308 113.606 340.8 116.135C404.673 118.589 437.476 68.6429 437.476 68.6429V42.0277Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.966 41.3606C272.12 188.383 168.699 -4.2247 88.4227 0.0710144C5.76851 4.51744 0 79.6638 0 49.707V94.5104C0 94.5104 27.1832 75.978 73.7747 70.302C242.827 49.707 252.683 233.917 331.254 214.237C409.825 194.557 464.545 0.835495 422.966 41.3606Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProceedToTakeTestBg);
export default __webpack_public_path__ + "static/media/proceedToTakeTestBg.c8da2369b07ec551578231404a662ba3.svg";
export { ForwardRef as ReactComponent };